import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import Box from "@mui/material/Box";
function TableRowExpanded({ row, detailColumns = [], renderDetailCell, renderSidePanel, }) {
    /**
     * Memoized detail columns to prevent unnecessary re-renders
     */
    const memoizedDetailColumns = useMemo(() => {
        return Array.isArray(detailColumns) ? detailColumns : [];
    }, [detailColumns]);
    const renderCellContent = (detailRow, columnGroup) => {
        if (renderDetailCell) {
            return renderDetailCell(detailRow, columnGroup);
        }
        return detailRow?.label || String(detailRow || "");
    };
    if (!memoizedDetailColumns.length && !renderSidePanel) {
        return null;
    }
    return (_jsxs(Box, { className: "table-row-expanded-container", children: [memoizedDetailColumns.length > 0 && (_jsx(Box, { className: "table-row-expanded-main", children: memoizedDetailColumns.map((columnGroup, groupIndex) => {
                    if (!columnGroup || !columnGroup.label)
                        return null;
                    const columnWidth = columnGroup.width || "auto";
                    const rows = Array.isArray(columnGroup.rows) ? columnGroup.rows : [];
                    return (_jsxs(Box, { className: "table-row-expanded-column-group", style: { width: columnWidth }, children: [_jsx(Box, { className: "table-row-expanded-header", children: columnGroup.label }), rows.length > 0 ? (rows.map((detailRow, detailIndex) => (_jsx(Box, { className: "table-row-expanded-cell", children: renderCellContent(detailRow, columnGroup) }, `detail-row-${detailIndex}-${detailRow?.label || detailIndex}`)))) : (_jsx(Box, { className: "table-row-expanded-cell", children: _jsx(Box, { sx: { color: "text.secondary", fontSize: "0.875rem" }, children: "No data" }) }))] }, `column-group-${groupIndex}-${columnGroup.label}`));
                }) })), renderSidePanel && (_jsx(Box, { className: "table-row-expanded-side-panel", children: renderSidePanel(row) }))] }));
}
export default TableRowExpanded;
